import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type ResourceViewType = "horizontal" | "vertical";

type ResourceViewState = {
  viewType: ResourceViewType;
  setViewType: (viewType: ResourceViewType) => void;
  toggleView: () => void;
};

export const useResourceViewStore = create<ResourceViewState>()(
  persist(
    (set, get) => ({
      viewType: "vertical",
      setViewType: (viewType: ResourceViewType) => {
        set({ viewType });
      },
      toggleView: () => {
        const { viewType } = get();
        set({ viewType: viewType === "vertical" ? "horizontal" : "vertical" });
      },
    }),
    {
      name: "resource-view-storage",
      storage: createJSONStorage(() => window.localStorage),
      version: 1,
    }
  )
);
